import React from 'react'

const NotFound = () => <div>404 page not found</div>

export default NotFound
